import { render, staticRenderFns } from "./material-guideline.vue?vue&type=template&id=ab218dfa&"
import script from "./material-guideline.vue?vue&type=script&lang=js&"
export * from "./material-guideline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/sw-41f73918-1793878079/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab218dfa')) {
      api.createRecord('ab218dfa', component.options)
    } else {
      api.reload('ab218dfa', component.options)
    }
    module.hot.accept("./material-guideline.vue?vue&type=template&id=ab218dfa&", function () {
      api.rerender('ab218dfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/roadrunner/Application/ViewComponents/Inshape/Admin/Materials/AddMaterial/GuidelineComponent/material-guideline.vue"
export default component.exports